import React, { useRef, useEffect, useState } from 'react';
import Modal from "@stencil/generic-modal-component";
import { useDispatch, useSelector } from 'react-redux';
import * as S from "./ReviewRating.styles";
import { reviewRatingDataSelector, reviewsDataSelector, loaderSelector } from '../../redux/selector';
import Icon from '../../../../../stories/core-components/IconsSelector';
import { fetchReviewsData } from '../../redux/thunks';
import InfiniteLoader from '../../../../../stories/core-components/InfiniteLoader/InfiniteLoader';


interface IProps {
    onClose: () => void
}

export default function ({ onClose = () => { } }: IProps) {
    const [loading, setLoading] = useState(true);
    const dispatch = useDispatch();
    const elRef = useRef();
    const reviewRatingData = useSelector(reviewRatingDataSelector);
    const reviewsData = useSelector(reviewsDataSelector);
    const loaders = useSelector(loaderSelector);
    const { review_str = '', review = {}, bar_list = [], rating_type = "", rate_breakup = [] } = reviewRatingData;
    const { title = '', reviews = [], hasMore = true } = reviewsData;
    const { isReviewsApi = false } = loaders;



    useEffect(() => {
        document.body.style.overflow = "hidden";
        dispatch(fetchReviewsData(reviewRatingData?.r_u)).then(() => {
            setLoading(false);
        });
        return () => {
          document.body.style.overflow = "auto";
        }
      }, [])

    return (
        <S.Overlay>
            <S.ReviewRatingWrapper>
                <S.RatingsWrapper>
                    <h4 className="font14 fontMedium textDark">{reviewRatingData?.t}</h4>
                    <p className="font14 textLightDark appendTop5">{review_str}</p>
                    <S.RatingContainer>
                        {!!review?.t && <div className={`RatingContainerLeft`} style={{ backgroundColor: review?.bc || "#1b9564" }}>
                            {!!rating_type && <p className="font14 fontMedium textWhite">{rating_type}</p>}
                            <p className="textWhite"><span className="font22 fontMedium rubik">{review?.t}/</span><span className="rubik textWhite font18">5</span></p>
                        </div>}
                        {rate_breakup?.length > 0 && <div>
                            {rate_breakup.map(({ color = "", fill_area = "", count = 0, title = "" }, index) => {
                                return (
                                    <div className="makeFlex hrtlCenter" key={index}>
                                        <p className="font14 appendRight8">
                                            {title}
                                        </p>
                                        <p><i className="star"></i></p>
                                        <S.RatingBar>
                                            <div
                                                className="fillBar"
                                                style={{
                                                    backgroundColor: color,
                                                    width: fill_area,
                                                }}
                                            />
                                        </S.RatingBar>
                                        <div className="width25">
                                            <p className="font12">
                                                {count}
                                            </p>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>}
                    </S.RatingContainer>
                    {bar_list?.length > 0 && <S.RatingBarWrapper>
                        {bar_list?.map(({ title = "", rating = "", fill_area = "", color = "" }) => {
                            return (
                                <div key={title} className="appendBottom16">
                                    <div className="makeFlex spaceBetween appendBottom8">
                                        <p className="font12 textDark rubik">{title}</p>
                                        <p className="font11 textDarkLight rubik">{rating}</p>
                                    </div>
                                    <S.RatingBar style={{ margin: 0 }}>
                                        <div className="fillBar" style={{ backgroundColor: color, width: fill_area }} />
                                    </S.RatingBar>
                                </div>
                            );
                        })}
                    </S.RatingBarWrapper>}
                </S.RatingsWrapper>
                <S.ReviewWrapper>
                    {!!title && <h4 className="font14 fontMedium textDark">{title}</h4>}
                    <S.ReviewContainer ref={elRef}>
                        {loading ? (
                            <div className="loading makeFlex perfectCenter font12 textDarkLight">Fetching Reviews...</div>
                        ) : (
                            <React.Fragment>
                                {reviews?.length > 0 ? (
                                    <InfiniteLoader
                                        showLoader={hasMore && isReviewsApi}
                                        actionHandler={() => {
                                            if (hasMore) {
                                                dispatch(fetchReviewsData(reviewRatingData?.r_u));
                                            }
                                        }}
                                        root={elRef.current}
                                    >
                                        {reviews?.map(({ sub_title = "", customer_name = "", textual_review = "", rating = {} }, index) => {
                                            const  { t = '', bc = '' } = rating || {}; 
                                            return (
                                                <div key={`${customer_name}-${index}`} className="reviewContainer appendTop28">
                                                    <div className="makeFlex spaceBetween hrtlCenter">
                                                        <div className="makeFlex hrtlCenter">
                                                            <div className="nameWrapper font11 makeFlex perfectCenter appendRight12">{customer_name ? customer_name?.slice(0, 2)?.toUpperCase() : ''}</div>
                                                            <div className="font14 fontMedium textDark">{customer_name}</div>
                                                        </div>
                                                        <div className="makeFlex hrtlCenter">
                                                            <div className="font12 textDarkLight">{sub_title}</div>
                                                            {!!t && (
                                                                <S.RatingTag bc={bc}>
                                                                    <span>{`${t}/5`}</span>
                                                                </S.RatingTag>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="appendTop28 font14 textDark">
                                                        {textual_review}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </InfiniteLoader>
                                ) : (
                                    <div className="loading makeFlex perfectCenter font12 textDarkLight">No Reviews Present</div>
                                )}
                            </React.Fragment>
                        )}
                </S.ReviewContainer>
            </S.ReviewWrapper>
                <S.CloseIconWrapper onClick={() => onClose()}>
                    <Icon name="ClosePopupIcon" />
                </S.CloseIconWrapper>
            </S.ReviewRatingWrapper>
        </S.Overlay>
    );
}